import { BrowserRouter, Routes, Route } from "react-router-dom";
import Surveyor from "./pages/Surveyor";
import Insured from "./pages/Insured";
import PreCheck from "./pages/Precheck";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/precheck/:aid" element={<PreCheck />} />

        {/* 🔹 Insured Live View */}
        <Route path="/insured/:aid" element={<Insured />} />

        {/* 🔹 Surveyor Live View */}
        <Route path="/surveyor/:aid" element={<Surveyor />} />

        {/* Optional fallback */}
        <Route path="*" element={<div>404 - Not Found</div>} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;